import styled from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';
import { Fontw4s10h12 } from 'styles/commonCss';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { createMarkup } from 'lib/utils/create-markup';
import { mqSmallMax } from 'styled/tools/media-queries';

const Footer = styled.footer`
  background: var(--fill-neutral-light);
`;

const Content = styled.section`
  display: flex;
  padding: 24px 48px;

  @media ${mqSmallMax} {
    padding: 24px 24px;
  }
`;

const Disclaimer = styled.small`
  width: 100%;
  padding: 12px;
  border: 1px solid var(--outline-neutral);

  p,
  i,
  b,
  u {
    ${Fontw4s10h12}
    color: var(--text-secondary);
  }

  b {
    font-weight: 500;
  }

  @media ${mqLargeMin} {
    width: 413px;
  }
`;

const HcpFooter = ({ disclaimer }) => (
  <Footer>
    <Content>
      {disclaimer && (
        <Disclaimer
          dangerouslySetInnerHTML={createMarkup(
            documentToHtmlString(disclaimer),
          )}
        />
      )}
    </Content>
  </Footer>
);

export default HcpFooter;
